function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRotateFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.986 9.821c-4.418 4.419-4.418 11.61 0 16.028 4.419 4.418 11.61 4.418 16.028 0 4.418-4.419 4.418-11.61 0-16.028a11.259 11.259 0 00-8.44-3.296l-.001 3.598L10.9 5.45 15.573.778v3.686a13.304 13.304 0 019.898 3.9c5.222 5.222 5.222 13.72 0 18.942-5.222 5.222-13.72 5.222-18.942 0-5.222-5.222-5.222-13.72 0-18.942l1.457 1.457z",
    fill: props.color
  }));
}

export default SvgIconRotateFilled;